/**
 * Main Application Entry Point
 * Imports and initializes all application modules
 */

// Import all modules
import './smooth-scroll.js';
import './scroll-animations.js';
import './mobile-menu.js';
import './gallery-swiper.js';

// Add hover effect to .btn elements to toggle .hoooray class on .header__logo
document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('mouseenter', () => {
        document.querySelector('.header__logo').classList.add('hoooray');
    });
    btn.addEventListener('mouseleave', () => {
        document.querySelector('.header__logo').classList.remove('hoooray');
    });
});